"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var crystal_ball_svg_1 = __importDefault(require("../../../../../assets/rubyJackpot/icons/crystal_ball.svg"));
var FeelingLuckyButton = function (_a) {
    var getRandomGame = _a.getRandomGame, _b = _a.hide, hide = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ type: "button", onClick: getRandomGame, className: (0, clsx_1.default)("feeling-lucky", {
            "hide": hide,
            "show": !hide,
        }) }, { children: [(0, jsx_runtime_1.jsx)("img", { src: crystal_ball_svg_1.default, alt: "crystalBall" }), (0, jsx_runtime_1.jsx)("span", { children: "Alege jocul norocos" })] })));
};
exports.default = FeelingLuckyButton;
